import Select, { MenuListProps, SingleValue } from "react-select"
import { FixedSizeList as List } from "react-window"
import { usePrevetTabStateContext } from "../hooks/prevetContext"
import {
  SelectOption,
  VesselListSingle,
  VesselSegmentInputSelection,
} from "./PrevetMain"
export interface ChosenVesselForSelect {
  imo: number
}

interface PrevetVesselSearchProps {
  vesselsData: VesselListSingle[] | undefined
  getVesselsLoading: boolean
  getVesselDetailsLoading: boolean
  chosenSegment: VesselSegmentInputSelection
  getChosenVessel: (args: ChosenVesselForSelect) => void
  setChosenSegment: (segment: VesselSegmentInputSelection) => void
  getVessels: ({
    segments,
    controller,
  }: {
    segments: string[]
    controller?: AbortController
  }) => Promise<void>
  vesselSegments: VesselSegmentInputSelection[]
  clearChosenVesselData: () => void
  chosenVessel: SelectOption | undefined
  setChosenVessel: React.Dispatch<
    React.SetStateAction<SelectOption | undefined>
  >
}
interface VirtualizedMenuListProps extends MenuListProps<SelectOption, false> {}

interface RenderRowProps {
  index: number
  style: React.CSSProperties
}

const VirtualizedMenuList = (props: VirtualizedMenuListProps) => {
  const { options, children, getValue } = props
  const value = getValue()
  const currentIndex = options.findIndex(
    (option) => "value" in option && option.value === value?.[0]?.value
  )
  const maxHeight = 300 // Max height of the dropdown
  const height = 35 // Height of each item in the dropdown

  const renderRow = ({ index, style }: RenderRowProps) => (
    <div style={style}>
      {children && (children as React.ReactNode[])[index]}
    </div>
  )

  return (
    <List
      height={maxHeight}
      itemCount={Array.isArray(children) ? children.length : 0}
      itemSize={height}
      initialScrollOffset={currentIndex * height}
      width="100%"
    >
      {renderRow}
    </List>
  )
}

export function PrevetVesselSearch({
  vesselsData,
  getVesselsLoading,
  getVesselDetailsLoading,
  chosenSegment,
  getChosenVessel,
  setChosenSegment,
  getVessels,
  vesselSegments,
  clearChosenVesselData,
  chosenVessel,
  setChosenVessel,
}: PrevetVesselSearchProps) {
  const { setTabStateValue } = usePrevetTabStateContext()

  const extractVesselName = (input: string): string => {
    const regex = /^(.*?)(?=\s+\S+\s*\()/
    const match = input.match(regex)
    return match ? match[0].trim() : ""
  }

  return (
    <>
      <Select
        components={{ MenuList: VirtualizedMenuList }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }), 
        }}
        options={
          vesselsData?.map((vessel) => ({
            value: vessel.value,
            label: vessel.label,
          })) || []
        }
        className="VesselSearch_Name w-100"
        isDisabled={getVesselDetailsLoading || getVesselsLoading}
        value={chosenVessel ? chosenVessel : null}
        placeholder={
          getVesselsLoading
            ? `Loading vessels...`
            : "Search by Vessel Name / IMO Number"
        }
        onChange={(vessel: SingleValue<SelectOption>) => {
          if (!vessel) {
            return
          }
          setTabStateValue(
            "tabName",
            extractVesselName(vessel.label),
            undefined
          )
          setTabStateValue("perfExposureValue", "", undefined)
          clearChosenVesselData()
          setChosenVessel(vessel)
          getChosenVessel({
            imo: Number(vessel.value),
          })
          setTabStateValue("imo", vessel, undefined)
        }}
      />
      {/*  <div className="VesselSearch_Segment">
        <Select
          defaultValue={defaultSegment}
          isDisabled={getVesselDetailsLoading || getVesselsLoading}
          options={vesselSegments}
          onChange={(segment: SingleValue<VesselSegmentInputSelection>) => {
            if (!segment) {
              return
            }
            setChosenVessel(undefined)
            clearChosenVesselData()
            setChosenSegment(segment)
            dispatch(setDefaultSegment(segment.value as VesselSegment))
            getVessels({ segment: segment.value })
          }}
        />
      </div> */}
    </>
  )
}
